import { TranslateLoader } from '@ngx-translate/core';
import { Observable, of } from 'rxjs';
import { TransferState, makeStateKey } from '@angular/core';
import { PLATFORM_ID, Inject } from '@angular/core';
import { isPlatformServer } from '@angular/common';
import { routeLoaderMap } from '../shared/routes/loader-map';

export class TranslateHttpLoader implements TranslateLoader {
  constructor(
    private transferState: TransferState,
    @Inject(PLATFORM_ID) private platformId: object
  ) {}

  /**
   * Gets the translations from server or transferkey
   */
  public getTranslation(lang: string): Observable<object> {
    // prepare and load translations from already loaded HTML
    const translationKey = makeStateKey<object>('translation-' + lang);
    // on iframe, no transferSate, check if 'hasKey' exists
    if (this.transferState.hasKey && this.transferState.hasKey(translationKey)) {
      const translations = this.transferState.get<object>(translationKey, null);
      this.transferState.remove(translationKey);
      return of(translations);
    }

    const ob = new Observable<object>(subscriber => {
      routeLoaderMap[lang]().then((langRoutes: object) => {
        if (isPlatformServer(this.platformId)) {
          this.transferState.set(translationKey, langRoutes);
        }
        subscriber.next(langRoutes);
      });
    });
    return ob;
  }
}
